<template>
  <div class="home-content-page-v">
    <!-- <div v-if="isAdmin" style="margin-bottom: 2rem;">
      <span style="color: #666;margin-right: 0.5rem;line-height: 2rem;">全部配送中心</span>
      <el-switch v-model="allPs"></el-switch>
    </div> -->
    <div class="content-one" v-loading="loading">
      <content-title :title="'历史数据状态'" :actions="titleAction" @clickMenu="clickTitleMenu"></content-title>
      <div class="output-content">
        <div class="output-content-2">
          <a href="javascript:;" class="data-one" :class="{'data-one-ok': item['status'] === 'ok', 'data-one-warning': item['status'] !== 'ok'}" v-for="item in hisData" @click="chooseOne(item)">
            <span>{{item['日期']}}</span>
            <span>进销存: {{item['jxc']}}</span>
            <span>配送计划: {{item['psjh']}}</span>
            <span>核销: {{item['hx']}}</span>
          </a>
        </div>
      </div>
    </div>
    <el-dialog :title="chooseHis['日期']" :visible.sync="showDetail" v-if="chooseHis" size="tiny">
      <div>
        <div class="content-one-w">
          <span>进销存: {{chooseHis['jxc']}}</span>
          <input type="file" @change="fileChangeJxc" :id="fileIdJxc" v-if="chooseHis['jxc'] === 0">
        </div>
        <div class="content-one-w">
          <span>配送计划: {{chooseHis['psjh']}}</span>
          <input type="file" @change="fileChangePsjh" :id="fileIdPsjh" v-if="chooseHis['psjh'] === 0">
        </div>
        <div class="content-one-w">
          <span>核销: {{chooseHis['hx']}}</span>
          <a href="javascript:;" class="this-btn" v-if="chooseHis['jxc'] !== 0" @click="hxJxc">核销</a>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  inputAllData
} from '@/api/oli_api'
import ContentTitle from '@/components_bit/ContentTitle'
export default {
  data () {
    return {
      titleAction: [{
        key: 'load',
        icon: 'icon-meitian'
      }],
      showDetail: false,
      loading: false,
      fileIdJxc: 'file-input-jxc',
      fileIdPsjh: 'file-input-psjh',
      hisData: [],
      dataType: null,
      chooseHis: null,
      canChooseDate: ''
    }
  },
  components: {
    ContentTitle
  },
  computed: {
    allPs: {
      get () {
        return this.$store.getters.userInfo && this.$store.getters.userInfo.USER_TYPE === 'manager'
      }
    }
  },
  created () {
    this.loadAllInputData()
  },
  methods: {
    clickTitleMenu (key) {
      if (key === 'load') {
        this.loadAllInputData()
      }
    },
    chooseOne (data) {
      if (data['日期'] === this.canChooseDate) {
        this.chooseHis = data
        this.showDetail = true
      } else if (data['status'] === 'ok') {
        this.chooseHis = data
        this.showDetail = true
      } else {
        this.$store.dispatch('showNoticeMsg', {
          type: 'warning',
          title: '系统提示',
          message: '请先处理' + this.canChooseDate + '数据'
        })
      }
    },
    loadAllInputData () {
      this.loading = true
      inputAllData({action: 'get_input_data', data: {dayNum: 10, allPs: this.allPs ? 1 : 0}}).then((data) => {
        data.forEach((item) => {
          if (item['jxc'] && item['psjh'] && item['hx']) {
            item['status'] = 'ok'
          } else {
            item['status'] = 'warning'
            this.canChooseDate = item['日期']
          }
        })
        this.hisData = data
        this.loading = false
      })
    },
    checkFile (files) {
      if (!files.length) {
        return null
      } else if (['xlsx', 'xls'].indexOf(files[0].name.split('.').slice(-1)[0]) > -1) {
        return files[0]
      } else {
        this.$store.dispatch('showNoticeMsg', {
          type: 'warning',
          title: '系统提示',
          message: '请选择excel文件。'
        })
        return false
      }
    },
    fileChangeJxc (e) {
      let fileInput = this.checkFile(e.target.files || e.dataTransfer.files)
      if (!fileInput) {
        document.getElementById(this.fileIdJxc).value = ''
      } else {
        this.inputJxcData(fileInput)
      }
    },
    fileChangePsjh (e) {
      let fileInput = this.checkFile(e.target.files || e.dataTransfer.files)
      if (!fileInput) {
        document.getElementById(this.fileIdPsjh).value = ''
      } else {
        this.inputPsData(fileInput)
      }
    },
    inputPsData (fileInput) {
      this.$store.dispatch('inputOlderPlan', {excelFile: fileInput, fileId: this.fileIdPsjh, date: this.chooseHis['日期']})
    },
    inputJxcData (fileInput) {
      this.$store.dispatch('dealJxcExceldata', {excelFile: fileInput, fileId: this.fileIdJxc, date: this.chooseHis['日期']})
    },
    hxJxc () {
      this.$store.dispatch('setHxDate', this.chooseHis['日期'])
      this.$store.dispatch('setAllPs', this.allPs)
      this.$router.push({'name': 'single.ruku_check'})
      this.$store.dispatch('loadWaitHx')
      this.showDetail = false
    }
  }
}
</script>

<style scoped lang="less">
@import '../../style/base.less';
.this-btn {
  background-color: #012e53;
  font-size: 0.8rem;
  letter-spacing: 3px;
  line-height: 1.2rem;
  border-radius: 0.2rem;
  padding: 0 1rem;  
  color: #fff;
}
.input-date {
  font-size: 1rem;
  color: #666;
  margin-top: 2rem;
}
.input-note-info {
  flex: 1;
  display: flex;
  align-items: center;
  font-size: 1.2rem;
  color: #999;
}
.content-one {
  display: flex;
  flex: 1;
  flex-direction: column;
  margin-bottom: 2em;
}
.content-one-w {
  margin: 1rem;
  display: flex;
  justify-content: space-between;
}
.output-btn {
  align-self: flex-end;
  color:#fff;
  background-color: @bak-color-2;
  padding: 0.5em 1.5em;
  text-align: center;
  border-radius: 0.3em;
  letter-spacing: 0.1em;
}
.output-content-2 {
  flex: 4;
  display: flex;
  flex-wrap: wrap;
  padding: 1rem;
}
.output-content {
  flex:1;
  .content-shadow;
  .content-bottom-radius;
  display: flex;
  padding: 2em;
  background-color: #fff;
}
.checkbox-label {
  .output-btn {
    margin-left: 3em;
  }
}
.btm-btn {
  margin: 1em 0 0 2em;
}
.m-line {
  width: 2px;
  background-color: #ccc;
  margin: 1.5em 2.2em 1.5em 0;
}
.output-content-1 {
  flex: 1;
  padding: 1em 2.5em 1em;
  margin-right: 1rem;
  display: flex;
  flex-direction: column;
  border-right: 0.2rem solid #ddd;
}
.data-one {
  width: 10rem;
  border-radius: 0.3rem;
  margin-right: 3rem;
  border: 2px solid #0b5591;
  color: #666;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: 1rem;
  span {
    line-height: 2rem;
  }
}
.data-one-ok {
  border-color: #13ce66;
}
.data-one-warning {
  border-color: #f7ba2a;
}
.checkbox-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  .iconfont {
    margin-left: 1rem;
  }
  .error-iconfont {
    color: @color-warning;
  }
  .suc-iconfont {
    line-height: 1;
    color: @color-suc;
  }
  span {
    line-height: 1;
    font-size: 1.13em;
    padding-bottom: 0.5em;
    color: @bak-color-2;
  }
  input {
    margin-top: 2rem;
  }
}

.checkbox-one {
  display: flex;
  align-items: center;
  height: 3.4em;
  font-size: 1em;
  color:@bak-color-1;
  img {
    padding-right: 1em;
  }
}
</style>



// WEBPACK FOOTER //
// input_data_date.vue?fca7efac